<!-- Start Content-->
<div class="container-fluid">
    <div class="row my-1">
        <div class="col-md-12">
            <div class="userTables">

                <div class="searchForm">
                    <form [formGroup]="balanceSheetFormData" (ngSubmit)="getBalanceSheetData('')" *ngIf="!router.url.includes('settlement')">
                        <div class="row">
                            <div class="col-md-2">
                                <label>From Date</label>
                                <input type="date" class="form-control" formControlName="start_date">
                            </div>
                            <div class="col-md-2">
                                <label>To Date</label>
                                <input type="date" class="form-control" formControlName="end_date">
                            </div>

                            <div class="col-md-2">
                                <label>&nbsp;</label>
                                <button type="submit" class="btn btn-gets"> <i class="mdi mdi-search-web"></i> Filter</button>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="row">
                    <div class="col-12">
                        <h2>{{router.url.includes('settlement') ? env.host.settlementHeading : 'balance sheet'}}</h2>
                        <!-- <div class="row" *ngIf="data?.settlementsPlusCollection.length > 0 || data?.settlementsMinusCollection.length > 0"> -->
                        <div class="row">
                            <div class="col-md-6">
                                <div class="table-responsive settlementPlus">
                                    <h3>Client in Plus (Profit)</h3>
                                    <table id="DataTable" class="table mb-0 table-bordered">
                                        <thead>
                                            <tr>
                                                <th>UT</th>
                                                <th>username</th>
                                                <th>chip</th>
                                                <th>action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngIf="data?.parentPlEntry?.transfer_amount >= 0">
                                                <td>#</td>
                                                <td>Up-Line P/L</td>
                                                <td class="text-green"><i class="fa fa-inr"></i>
                                                    {{fixedTwoDec(data?.parentPlEntry?.transfer_amount)}}</td>
                                                <td>-</td>
                                            </tr>
                                            <tr *ngIf="data?.ownPlEntry?.transfer_commission_in >= 0">
                                                <td>#</td>
                                                <td>My Commission</td>
                                                <td class="text-green"><i class="fa fa-inr"></i>
                                                    {{fixedTwoDec(data?.ownPlEntry?.transfer_commission_in)}}</td>
                                                <td>-</td>
                                            </tr>
                                            <tr *ngIf="data?.ownPlEntry?.transfer_amount >= 0">
                                                <td>#</td>
                                                <td>My P/L</td>
                                                <td class="text-green"><i class="fa fa-inr"></i>
                                                    {{fixedTwoDec(data?.ownPlEntry?.transfer_amount)}}</td>
                                                <td>-</td>
                                            </tr>
                                            <tr *ngIf="data?.childrenCash?.transfer_amount && data?.childrenCash?.transfer_amount < 0">
                                                <td>#</td>
                                                <td>My Cash</td>
                                                <td class="text-green"><i class="fa fa-inr"></i>
                                                    {{fixedTwoDec(-data?.childrenCash?.transfer_amount)}}</td>
                                                <td>
                                                    <a href="javascript:void(0);" *ngIf="router.url.includes('settlement')"
                                                    routerLink="/reports/settlement-report/{{data?.user?.id}}"
                                                    class="btn btn-option" data-toggle="tooltip" data-placement="top"
                                                    title="History">h</a>
                                                </td>
                                            </tr>
                                            <tr *ngIf="data?.myRunningPl >= 0">
                                                <td>#</td>
                                                <td>My Running P/L</td>
                                                <td class="text-green"><i class="fa fa-inr"></i> {{data?.myRunningPl.toFixed(2)}}
                                                </td>
                                                <td>-</td>
                                            </tr>
                                            <tr
                                                *ngFor="let item of data?.settlementsPlusCollection;let i=index;trackBy:trackByIndex;">
                                                <td>{{(item?.role_id == 1) ? 'A' : (item?.role_id == 2) ? 'S' : (item?.role_id
                                                    == 3) ? 'M' : 'C'}}</td>
                                                <td>
                                                    <a *ngIf="item?.role_id != 4" href="javascript:void(0)" [routerLink]="router.url.includes('settlement') ? ['/settlement', item?.user_id] : ['/balance-sheet', item?.user_id]">{{item?.username}} [{{item?.name}}]</a>
                                                    <span *ngIf="item?.role_id == 4">{{item?.username}} [{{item?.name}}]</span></td>
                                                <td class="text-green"><i class="fa fa-inr"></i> {{item?.transfer_amount}}</td>
                                                <td>
                                                    <div class="btn-group">
                                                        <!-- <a href="deposit.php" class="btn btn-d" data-toggle="tooltip" data-placement="top" title="Deposit">c</a> -->
                                                        <a href="javascript:void(0);" *ngIf="router.url.includes('settlement')"
                                                            (click)="openModal(settlementModal, i, item, 1)" class="btn btn-option"
                                                            data-toggle="tooltip" data-placement="top" title="Settlement">s</a>
                                                        <a href="javascript:void(0);" *ngIf="router.url.includes('settlement')"
                                                            routerLink="/reports/settlement-report/{{item?.user_id}}"
                                                            class="btn btn-option" data-toggle="tooltip" data-placement="top"
                                                            title="History">h</a>
                                                        <a href="javascript:void(0);" *ngIf="!router.url.includes('settlement')"
                                                            routerLink="/reports/account-statement/{{item?.user_id}}"
                                                            class="btn btn-option" data-toggle="tooltip" data-placement="top"
                                                            title="Statement">s</a>
                                                    </div>
                                                </td>
                                            </tr>
        
                                            <tr class="bg-profit">
                                                <td>#</td>
                                                <td>Total</td>
                                                <td class="text-green"><i class="fa fa-inr"></i> {{data?.totalPlus.toFixed(2)}}</td>
                                                <td></td>
                                            </tr>
        
                                        </tbody>
                                    </table>
                                </div>
                            </div>
        
                            <div class="col-md-6">
                                <div class="table-responsive settlementLoss">
                                    <h3>Client in Minus (loss)</h3>
                                    <table id="DataTableTwo" class="table mb-0 table-bordered">
                                        <thead>
                                            <tr>
                                                <th>UT</th>
                                                <th>username</th>
                                                <th>chip</th>
                                                <th>action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
        
                                            <tr *ngIf="data?.parentPlEntry?.transfer_amount < 0">
                                                <td>#</td>
                                                <td>Up-Line P/L</td>
                                                <td class="text-red"><i class="fa fa-inr"></i>
                                                    {{fixedTwoDec(-data?.parentPlEntry?.transfer_amount)}}</td>
                                                <td>-</td>
                                            </tr>
                                            <tr *ngIf="data?.ownPlEntry?.transfer_commission_in < 0">
                                                <td>#</td>
                                                <td>My Commission</td>
                                                <td class="text-red"><i class="fa fa-inr"></i>
                                                    {{fixedTwoDec(-data?.ownPlEntry?.transfer_commission_in)}}</td>
                                                <td>-</td>
                                            </tr>
                                            <tr *ngIf="data?.ownPlEntry?.transfer_amount < 0">
                                                <td>#</td>
                                                <td>My P/L</td>
                                                <td class="text-red"><i class="fa fa-inr"></i>
                                                    {{fixedTwoDec(-data?.ownPlEntry?.transfer_amount)}}</td>
                                                <td>-</td>
                                            </tr>
                                            <tr *ngIf="data?.childrenCash?.transfer_amount && data?.childrenCash?.transfer_amount >= 0">
                                                <td>#</td>
                                                <td>My Cash</td>
                                                <td class="text-red"><i class="fa fa-inr"></i>
                                                    {{fixedTwoDec(data?.childrenCash?.transfer_amount)}}</td>
                                                <td>
                                                    <a href="javascript:void(0);" *ngIf="router.url.includes('settlement')"
                                                    routerLink="/reports/settlement-report/{{data?.user?.id}}"
                                                    class="btn btn-option" data-toggle="tooltip" data-placement="top"
                                                    title="History">h</a>
                                                </td>
                                            </tr>
                                            <tr *ngIf="data?.myRunningPl < 0">
                                                <td>#</td>
                                                <td>My Running P/L</td>
                                                <td class="text-red"><i class="fa fa-inr"></i> {{-data?.myRunningPl.toFixed(2)}}
                                                </td>
                                                <td>-</td>
                                            </tr>
                                            <tr
                                                *ngFor="let item of data?.settlementsMinusCollection;let i=index;trackBy:trackByIndex;">
                                                <td>{{(item?.role_id == 1) ? 'A' : (item?.role_id == 2) ? 'S' : (item?.role_id
                                                    == 3) ? 'M' : 'C'}}</td>
                                                <td>
                                                    <a *ngIf="item?.role_id != 4" href="javascript:void(0)" [routerLink]="router.url.includes('settlement') ? ['/settlement', item?.user_id] : ['/balance-sheet', item?.user_id]">{{item?.username}} [{{item?.name}}]</a>
                                                    <span *ngIf="item?.role_id == 4">{{item?.username}} [{{item?.name}}]</span>
                                                </td>
                                                <td class="text-red"><i class="fa fa-inr"></i> {{item?.transfer_amount}}</td>
                                                <td>
                                                    <div class="btn-group">
                                                        <!-- <a href="deposit.php" class="btn btn-d" data-toggle="tooltip" data-placement="top" title="Deposit">c</a> -->
                                                        <a href="javascript:void(0);" *ngIf="router.url.includes('settlement')"
                                                            (click)="openModal(settlementModal, i, item, 2)" class="btn btn-option"
                                                            data-toggle="tooltip" data-placement="top" title="Settlement">s</a>
                                                        <a href="javascript:void(0);" *ngIf="router.url.includes('settlement')"
                                                            routerLink="/reports/settlement-report/{{item?.user_id}}"
                                                            class="btn btn-option" data-toggle="tooltip" data-placement="top"
                                                            title="History">h</a>
                                                        <a href="javascript:void(0);" *ngIf="!router.url.includes('settlement')"
                                                            routerLink="/reports/account-statement/{{item?.user_id}}"
                                                            class="btn btn-option" data-toggle="tooltip" data-placement="top"
                                                            title="Statement">s</a>
                                                    </div>
                                                </td>
                                            </tr>
        
                                            <tr class="bg-loss">
                                                <td>#</td>
                                                <td>Total</td>
                                                <td class="text-red"><i class="fa fa-inr"></i> {{data?.totalMinus < 0 ? -data?.totalMinus.toFixed(2) : data?.totalMinus.toFixed(2)}}</td>
                                                <td></td>
                                            </tr>
        
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="no-data" *ngIf="data?.settlementsPlusCollection.length == 0 && data?.settlementsMinusCollection.length == 0">
                            {{env.noDataMsg}}
                        </div> -->
                        <app-loader class="no-overlay" *ngIf="!data"></app-loader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #settlementModal>
    <div class="modal-header">
        <h4 class="modal-title pull-left">SETTLEMENT FOR {{modalData?.username}}</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <span><small>Total Outstanding Amount : {{modalData?.transfer_amount}}</small></span>
        <form id="" class="admin_form" [formGroup]="formData" *ngIf="data" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label>Amount:</label>
                <input type="number" name="Demo" formControlName="settlement_amount" id="" class="form-control">
            </div>
            <div class="form-group">
                <label>Note</label>
                <input type="text" name="" formControlName="settlement_note" id="" class="form-control">
            </div>

            <div class="form-group text-left" *ngIf="modalData?.role_id == 4 && formData.value.settlement_side == 2">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck" formControlName="deposit_chips">
                    <label style="color: red;" class="custom-control-label" for="customCheck">Do you want to Deposit Chips (With Chips) ?</label>
                </div>
            </div>

            <div class="form-group" *ngIf="data?.is_parent_password_required == 1">
                <label>Master Password *</label><br>
                <input type="password" formControlName="parent_password" name="" id="" class="form-control"
                    autocomplete="off">
            </div>

            <div class="form-group">
                <div>
                    <button class="btn btnSubmit" type="submit" [disabled]="formData.invalid || submitted">submit</button>
                    <!-- <button class="btn btnCancel" (click)="cancel()">cancel</button> -->
                </div>
            </div>
        </form>
        <app-loader class="full-overlay" *ngIf="submitted"></app-loader>
    </div>
</ng-template>